export enum INTERVIEW_DETAIL_MODULES {
  APPLICANT_PARTICULARS = 'APPLICANT_PARTICULARS',
  INTERVIEW_DETAIL = 'INTERVIEW_DETAIL',
}
